import type { MetricKey } from './types';

const WEIGHT_SUM = 4.3;

export interface MetricDef {
    key: MetricKey;
    i18nKey: string;
    target: number;
    /** 容忍度：gap 达到该值时 sev 约为 ln2 */
    tolerance: number;
    weight: number;
}

/** 与原型 scoring.ts 的 METRIC_CONFIG 一一对应，目标值/容忍度用于前端展示公式说明 */
export const METRIC_DEFS: MetricDef[] = [
    { key: 'pickupRate', i18nKey: 'pickupRate', target: 99.5, tolerance: 0.06, weight: 1.0 / WEIGHT_SUM },
    { key: 'deliveryRate', i18nKey: 'deliveryRate', target: 98.0, tolerance: 0.25, weight: 1.5 / WEIGHT_SUM },
    { key: 'pickupWithin12hRate', i18nKey: 'pickupWithin12hRate', target: 90.0, tolerance: 8.0, weight: 0.8 / WEIGHT_SUM },
    { key: 'deliveryWithin24hRate', i18nKey: 'deliveryWithin24hRate', target: 96.0, tolerance: 4.0, weight: 1.0 / WEIGHT_SUM },
];

export const METRIC_DEF_BY_KEY: Record<MetricKey, MetricDef> = METRIC_DEFS.reduce(
    (acc, def) => ({ ...acc, [def.key]: def }),
    {} as Record<MetricKey, MetricDef>,
);

/** DSP 入选门槛：当日到货 ≥ 5 单且异常分 > 0，取前 3 */
export const DSP_MIN_ARRIVALS = 5;
export const DSP_TOP_N = 3;

export const LIGHT_COLORS: Record<string, string> = {
    RED: '#cf1322',
    YELLOW: '#d48806',
    GREEN: '#389e0d',
};

/** 归因原因九项 */
export const REASON_OPTIONS: { value: string; i18nKey: string }[] = [
    { value: 'CAPACITY_SHORTAGE', i18nKey: 'capacityShortage' },
    { value: 'LINEHAUL_DELAY', i18nKey: 'linehaulDelay' },
    { value: 'DRIVER_RETURN_NOT_INSERTED', i18nKey: 'driverReturnNotInserted' },
    { value: 'HUB_MISSORT', i18nKey: 'hubMissort' },
    { value: 'SYSTEM_OR_DEVICE', i18nKey: 'systemOrDevice' },
    { value: 'ADDRESS_OR_ACCESS', i18nKey: 'addressOrAccess' },
    { value: 'WEATHER_OR_TRAFFIC', i18nKey: 'weatherOrTraffic' },
    { value: 'BACKLOG_NOT_SHELVED', i18nKey: 'backlogNotShelved' },
    { value: 'OTHER', i18nKey: 'other' },
];

export const REASON_OPTION_BY_VALUE = REASON_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.value]: option }),
    {} as Record<string, { value: string; i18nKey: string }>,
);

export const TREND_DAYS = 30;
